function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  // Find the region form
  _toConsumableArray(document.querySelectorAll('.js-region-select')).forEach(function (form) {
    // Find the select element
    var select = form.querySelector('select');
    // Find the confirm button
    // const confirm = form.querySelector('button');
    // Store some timeouts
    var timeouts = {};
    // Store the initial region
    var initialRegion = select === null || select === void 0 ? void 0 : select.value;
    // The XHR request
    // const xhr = new XMLHttpRequest();
    // XHR URL
    // const url = '/api/close?region=';

    var onChange = function onChange() {
      var selected = select.SimpleSelector.selection[0] || false;
      var value = selected ? selected.default.value : false;
      if (!value || value === initialRegion) return;
      clearTimeout(timeouts.submit);
      dataLayer.push({
        event: "country_selected",
        country_value: value
      });
      timeouts.submit = setTimeout(function () {
        return form.submit();
      }, 100);
    };
    if (!select) return;
    select.addEventListener('SimpleSelector:close', onChange);

    // // When the confirm button is clicked, remove the form
    // confirm.addEventListener('click', (e) => {
    //   e.preventDefault();

    //   form.parentNode.removeChild(form);
    //   window.equalizers['header'].update();

    //   // Abort the XHR request
    //   xhr.abort();

    //   // Open the request
    //   xhr.open('POST', url + select.value, true);

    //   // Set the request headers
    //   xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    //   // Send the request
    //   xhr.send();
    // });
  });
})();